<section class="login-section">
  <div class="container">
    <div class="row justify-content-center login">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
        <div class="login-card card border border-light-subtle rounded-3 shadow-sm">
          <div class="card-body p-3 p-md-4 p-xl-5">
            <div class="login-logo">
              <img src="assets/images/logo-dark.png" class="img-fluid" alt="Digital Buyers Manager" />
            </div>

            <!-- LOGIN FORM -->
            <form [formGroup]="form" *ngIf="!showMfa">
              <div class="row gy-2 overflow-hidden login">
                <div class="col-12">
                  <label for="email" class="form-label">{{
                    "login.email" | translate
                    }}</label>
                  <div class="mb-3">
                    <input type="email" class="form-control" name="email" id="email" formControlName="email"
                      placeholder="{{ 'login.email' | translate }}" required />
                  </div>
                </div>
                <div class="col-12">
                  <label for="password" class="form-label">{{
                    "login.password" | translate
                    }}</label>
                  <div class="mb-3">
                    <input type="password" class="form-control" name="password" id="password" formControlName="password"
                      value="" placeholder="{{ 'login.password' | translate }}" required />
                  </div>
                </div>
                <div class="col-12">
                  <div class="d-flex gap-2 justify-content-between">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" name="rememberMe" id="rememberMe" />
                      <label class="form-check-label text-secondary" for="rememberMe">
                        {{ "login.remember" | translate }}
                        <menu type="context"></menu>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="d-flex flex-column align-items-center my-3">
                    <button type="submit" class="btn btn-primary btn-login" (click)="onLogin()">
                      {{ "buttons.login" | translate }}
                    </button>
                    <a href="/recover-password" class="link-primary text-decoration-none mt-3 forgot">{{ "login.forgot"
                      |
                      translate }}</a>
                  </div>
                </div>
              </div>
            </form>

            <!-- MFA VERIFICATION -->
            <div *ngIf="showMfa" class="mfa-section">
              <div class="text-center mb-4">
                <i class="icon-lock mfa-icon"></i>
                <h5 class="mt-2">{{ 'login.mfa.title' | translate }}</h5>
                <p class="text-muted small">{{ 'login.mfa.subtitle' | translate }}</p>
              </div>

              <!-- Error message -->
              <div *ngIf="mfaError" class="alert alert-danger small py-2 px-3" role="alert">
                {{ mfaError | translate }}
              </div>

              <!-- Code input -->
              <div class="mb-3">
                <label for="mfaCode" class="form-label">{{ 'login.mfa.code_label' | translate }}</label>
                <input
                  type="text"
                  class="form-control text-center mfa-input"
                  id="mfaCode"
                  [(ngModel)]="mfaCode"
                  maxlength="6"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  autocomplete="one-time-code"
                  placeholder="000000"
                  (keyup.enter)="onVerifyCode()"
                />
              </div>

              <!-- Remember device checkbox -->
              <div class="form-check mb-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="rememberDevice"
                  [(ngModel)]="rememberDevice"
                />
                <label class="form-check-label text-secondary small" for="rememberDevice">
                  {{ 'login.mfa.remember_device' | translate }}
                </label>
              </div>

              <!-- Verify button -->
              <div class="d-flex flex-column align-items-center mb-3">
                <button
                  type="button"
                  class="btn btn-primary btn-login w-100"
                  (click)="onVerifyCode()"
                  [disabled]="mfaCode.length !== 6"
                >
                  {{ 'login.mfa.verify_btn' | translate }}
                </button>
              </div>

              <!-- Resend + countdown -->
              <div class="text-center mb-2">
                <button
                  type="button"
                  class="btn btn-link btn-sm text-decoration-none"
                  (click)="onResendCode()"
                  [disabled]="countdown > 0"
                >
                  <ng-container *ngIf="countdown > 0">
                    {{ 'login.mfa.resend_countdown' | translate }} ({{ countdown }}s)
                  </ng-container>
                  <ng-container *ngIf="countdown === 0">
                    {{ 'login.mfa.resend_btn' | translate }}
                  </ng-container>
                </button>
              </div>

              <!-- Back to login -->
              <div class="text-center">
                <a class="link-secondary text-decoration-none small" href="javascript:void(0)" (click)="onBackToLogin()">
                  <i class="icon-arrow-left"></i> {{ 'login.mfa.back_to_login' | translate }}
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
